export default "__VITE_ASSET__DvYBHz3I__"